import { Button } from 'antd';
import React, { useState } from 'react';
import { saveAs } from 'file-saver';
import PropTypes from 'prop-types';
import apiService from '../../../axios/apiService';
import { getBlobFromBase64 } from '../../../utils/file';
import { APP_TERMS } from '../../../app-terms';
import { WORD_FILE_MIME_TYPE } from '../../../appContants';

const CaseReportTemplateDownloader = ({ caseId }) => {
  const [loading, setLoading] = useState(false);
  const handleDownloadCaseReportTemplate = async () => {
    try {
      setLoading(true);
      const response = await apiService.getCaseReportTemplate(caseId);
      const blob = await getBlobFromBase64(response, WORD_FILE_MIME_TYPE);
      saveAs(blob, `${APP_TERMS.generic_report} ${APP_TERMS.generic_template}`);
    } catch (error) {
      console.log('Error on report template get: ', error);
    } finally {
      setLoading(false);
    }
  };

  return caseId ? (
    <Button
      loading={loading}
      onClick={handleDownloadCaseReportTemplate}
      icon={<i className="fa fa-download"></i>}
    >
      Download Report Template
    </Button>
  ) : null;
};

CaseReportTemplateDownloader.propTypes = {
  caseId: PropTypes.string,
};
export default CaseReportTemplateDownloader;
